import { Directive, Input, OnChanges, OnDestroy, SimpleChanges, TemplateRef } from '@angular/core';
import { DEFAULT_PAGE_TITLE_STATE } from '@models/layout-state.model';
import { LayoutMediatorService } from '@services/view/layout-mediator-service/layout-mediator.service';
import { ViewService } from 'tangoe-design-system';

@Directive({
  selector: '[ts-page-title]'
})
export class PageTitleDirective implements OnChanges, OnDestroy {
  @Input('navigation_title') navigation_title: string = DEFAULT_PAGE_TITLE_STATE.navigation_title;
  @Input('page_title') page_title: string = DEFAULT_PAGE_TITLE_STATE.page_title;
  @Input('bg') bg: boolean = DEFAULT_PAGE_TITLE_STATE.bg;
  @Input('sticky') sticky: boolean = DEFAULT_PAGE_TITLE_STATE.sticky;
  @Input('nav_content') content: TemplateRef<any> | null = null;

  constructor(private layout_mediator: LayoutMediatorService, private view_svc: ViewService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.view_svc.requestAnimationFrame(() => {
      this.layout_mediator.setPageTitleState({
        navigation_title: this.navigation_title,
        page_title: this.page_title,
        bg: this.bg,
        sticky: this.sticky
      });
      this.layout_mediator.setPageTitleContent(this.content);
    });
  }

  ngOnDestroy(): void {
    this.layout_mediator.setPageTitleState(DEFAULT_PAGE_TITLE_STATE);
    this.layout_mediator.setPageTitleContent(null);
  }
}
